/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated from: notification.fga
 * Run: pnpm run gen:permissions -- notification
 */

import type { ModulePermissions } from './types';

export const notificationPermissions = {
  module: 'notification',
  displayName: 'Notification',
  entities: [
    {
      name: 'notification',
      displayName: 'Notification',
      permissions: [
        { key: 'notificationRead', action: 'Read', category: 'crud' },
        { key: 'notificationCreate', action: 'Create', category: 'crud' },
        { key: 'notificationUpdate', action: 'Update', category: 'crud' },
        { key: 'notificationDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'notificationDevice',
      displayName: 'Notification Device',
      permissions: [
        { key: 'notificationDeviceRead', action: 'Read', category: 'crud' },
        { key: 'notificationDeviceCreate', action: 'Create', category: 'crud' },
        { key: 'notificationDeviceUpdate', action: 'Update', category: 'crud' },
        { key: 'notificationDeviceDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'notificationPreference',
      displayName: 'Notification Preference',
      permissions: [
        { key: 'notificationPreferenceRead', action: 'Read', category: 'crud' },
        {
          key: 'notificationPreferenceCreate',
          action: 'Create',
          category: 'crud',
        },
        {
          key: 'notificationPreferenceUpdate',
          action: 'Update',
          category: 'crud',
        },
        {
          key: 'notificationPreferenceDelete',
          action: 'Delete',
          category: 'crud',
        },
      ],
    },
    {
      name: 'notificationRecipient',
      displayName: 'Notification Recipient',
      permissions: [
        { key: 'notificationRecipientRead', action: 'Read', category: 'crud' },
        {
          key: 'notificationRecipientCreate',
          action: 'Create',
          category: 'crud',
        },
        {
          key: 'notificationRecipientUpdate',
          action: 'Update',
          category: 'crud',
        },
        {
          key: 'notificationRecipientDelete',
          action: 'Delete',
          category: 'crud',
        },
      ],
    },
    {
      name: 'notificationType',
      displayName: 'Notification Type',
      permissions: [
        { key: 'notificationTypeRead', action: 'Read', category: 'crud' },
      ],
    },
  ],
} as const satisfies ModulePermissions;

/**
 * Union type of all permission keys in the Notification module
 */
export type NotificationPermissionKey =
  | 'notificationRead'
  | 'notificationCreate'
  | 'notificationUpdate'
  | 'notificationDelete'
  | 'notificationDeviceRead'
  | 'notificationDeviceCreate'
  | 'notificationDeviceUpdate'
  | 'notificationDeviceDelete'
  | 'notificationPreferenceRead'
  | 'notificationPreferenceCreate'
  | 'notificationPreferenceUpdate'
  | 'notificationPreferenceDelete'
  | 'notificationRecipientRead'
  | 'notificationRecipientCreate'
  | 'notificationRecipientUpdate'
  | 'notificationRecipientDelete'
  | 'notificationTypeRead';
